module.exports = __webpack_public_path__ + "img/officialManage.25789dfd.png";